import { render, staticRenderFns } from "./shouxin.vue?vue&type=template&id=634e8476&scoped=true"
import script from "./shouxin.vue?vue&type=script&lang=js"
export * from "./shouxin.vue?vue&type=script&lang=js"
import style0 from "./shouxin.vue?vue&type=style&index=0&id=634e8476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634e8476",
  null
  
)

export default component.exports